































import {Prop, Vue} from 'vue-property-decorator';
import Component from "vue-class-component";
import RoomNotifConfig from "@/types/RoomNotifConfig";
import api from "@/services/apiService";
import {ToasterType} from "@/types/ToasterConfig";
import {ErrorService} from "@/services/ErrorService";

@Component
export default class RoomNotif extends Vue {

  @Prop({
    type: Object,
    default: {
      class: '',
      illustration: '',
      title: '',
      message: '',
      timer: '',
      button: false,
      isLoading: false,
    }
  })
  public roomNotifConfig!: RoomNotifConfig;

  public isLoading: boolean = false;

  async unlockRoom() {
    this.isLoading = true;
    await api.authRequest.get('/nuki/open')
      .then((response) => {
        this.$store.commit('updateToaster', {
          type: ToasterType.Green,
          message: 'Ouverture de la porte, merci de patientez quelques secondes.',
        });
      }).catch((error) => {
        ErrorService.dealWithTheError(error);
      }).finally(() => {
        this.isLoading = false;
      });
  }
}

